import { createLazyFileRoute } from "@tanstack/react-router";

import { NewClientPage } from "@/features/admin/routes/ClientNew";

export const Route = createLazyFileRoute("/_auth/admin/clients/new")({
  component: NewClientPage,
});
